export default {
  complex: {
    avg_price_sqm: 'm² başına ortalama fiyat',
    min_price: 'Minimum fiyat',
    max_price: 'Maksimum fiyat',
    expected_delivery: 'Tahmini teslim tarihi',
    construction_start: 'İnşaat başlangıcı',
    construction_end: 'İnşaat bitişi',
    sales_start: 'Satış başlangıcı',
    distance_to_sea: 'Denize mesafe',
    distance_to_center: 'Merkeze mesafe',
    distance_to_airport: 'Havaalanına mesafe',
    roi: 'ROI tahmini',
    amenities: 'Olanaklar',
    yes: 'Evet',
    no: 'Hayır',
    infrastructure: 'Altyapı',
    nearby: 'Yakında',
    gallery: 'Galeri',
    video: 'Video',

    // zaten eklenmiş anahtarlar
    total: 'Toplam ünite',
    available: 'Mevcut',
    buildings: 'Binalar',
    floors_short: 'kat',
    cover_alt: 'Konut projesi kapak görseli',

    // 🔹 bileşen için yeni anahtarlar
    details: {
      developer: 'Müteahhit',
      location: 'Konum',
      country: 'Ülke',
      region: 'Bölge',
      city: 'Şehir',
      district: 'Semt',
      characteristics: 'Özellikler',
      class: 'Sınıf',
      buildings_count: 'Bina sayısı',
      construction_start: 'İnşaat başlangıcı',
      sales_start: 'Satış başlangıcı',
      construction_end: 'İnşaat bitişi',
      delivery: 'Teslim',
      investments_prices: 'Yatırımlar ve fiyatlar',
      total_value_available: 'Mevcut dairelerin toplam değeri',
      price_from: 'Başlangıç fiyatı',
      price_to: 'Bitiş fiyatı',
      price_per_sqm: 'm² başına fiyat',
      roi: 'ROI tahmini',
      amenities: 'Olanaklar',
      infrastructure: 'Altyapı',
      description: 'Açıklama',
      distances: 'Mesafeler',
      to_sea: 'Denize mesafe',
      to_center: 'Merkeze mesafe',
      to_airport: 'Havaalanına mesafe'
    },

    // olanaklar için örnek anahtarlar
    amenities: {
      pool: 'Havuz',
      parking: 'Otopark',
      gym: 'Spor salonu',
      security: 'Güvenlik'
      // backend’deki diğerleri eklenebilir
    },

    // altyapı için örnek anahtarlar
    infrastructure: {
      school: 'Okul',
      kindergarten: 'Anaokulu',
      supermarket: 'Süpermarket',
      hospital: 'Hastane'
      // backend’deki diğerleri eklenebilir
    },

    properties_in_complex: 'Bu projedeki daireler',
    description: 'Açıklama'
  },
  residential_class: {
    complex: {
      class: 'Sınıf'
    }
  },
  loading: 'Yükleniyor...'
}
